import { http } from './api'

const resource = 'distribuicao-online'

export default {
    listar: (params) => {
        return http.get(`${resource}`, { params: { ...params } })
    },

    pesquisarInscricoes: (params) => {
        return http.get(`${resource}/pesquisar-inscricoes`, { params: { ...params } })
    },

    admCorrigeInscricao: (params) => {
        return http.post(`${resource}/adm-corrigir-inscricao`, { params: { ...params } })
    },

    obterInscricoes1Cargo: (params) => {
        return http.post(`distribuicao-online/obter-inscricoes-1cargo`, { ...params })
    },
    
    obterInscricoesPEB: (params) => {
        return http.post(`distribuicao-online/obter-inscricoes-peb`, { ...params })
    },

    obterInscricoesExtensaoCargaHoraria: (params) => {
        return http.post(`distribuicao-online/obter-inscricoes-extensao-carga-horaria`, { ...params })
    },

    consultaInscricoes1Cargo: (params) => {
        return http.post(`distribuicao-online/consulta-inscricoes-1cargo`, { ...params })
    },
    
    consultaInscricoesPEB: (params) => {
        return http.post(`distribuicao-online/consulta-inscricoes-peb`, { ...params })
    },

    consultaInscricoesExtensaoCargaHoraria: (params) => {
        return http.post(`distribuicao-online/consulta-inscricoes-extensao-carga-horaria`, { ...params })
    },
    listarAulasDistribuidas:(aaletivo, cdpessoal, cdmatric) => {
        return http.get(`${resource}/aulas-distribuidas/${aaletivo}/${cdpessoal}/${cdmatric}`)    
    }
}